import SimpleTable from "@/components/SimpleTable";
import { handleCompanyUserName } from "@/lib/handleName";
import { calculateGrade } from "@/lib/utils";
import { AppAssessmentProgress } from "@/schema/AssessmentProgress";
import ActionButton from "@/src/app/(auth)/history/_components/ActionButton";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface HistoryTableProps {
  data: AppAssessmentProgress[];
  isLoading: boolean;
}

function HistoryTable({ data, isLoading }: HistoryTableProps) {
  const { t } = useTranslation();

  return (
    <SimpleTable
      data={data}
      isLoading={isLoading}
      columns={[
        {
          key: "updatedAt",
          label: t("submissionDate"),
          render: ({ updated_at }) => format(updated_at, t("date-format")),
        },
        {
          key: "status",
          label: t("status"),
          render: ({ status: { name } }) => name,
        },
        {
          key: "results",
          label: t("results"),
          render: ({ score }) =>
            score ? (
              <div className="flex-col">
                <div className=" ">{calculateGrade(score)}</div>
                <div className="text-cool-gray-600">
                  {score} {t("points")}
                </div>
              </div>
            ) : (
              <div>---</div>
            ),
        },
        {
          key: "submittedBy",
          label: t("submitted-by"),
          render: ({ submitted_by }) =>
            submitted_by
              ? handleCompanyUserName(submitted_by.id, submitted_by.name)
              : "---",
        },
        {
          key: "actions",
          label: t("action"),
          render: ({
            id,
            status: { id: statusId },
            has_first_evaluation_report,
            has_improvement_proposal,
            has_second_evaluation_report,
          }) => {
            return (
              <ActionButton
                id={id}
                statusId={statusId}
                hasFirstEvaluationReport={has_first_evaluation_report}
                hasSecondEvaluationReport={has_second_evaluation_report}
                hasImprovementProposal={has_improvement_proposal}
              />
            );
          },
        },
      ]}
    />
  );
}

export default HistoryTable;
